export enum paytableAssetConfig {
    //barImage = "assets/paytable/bar.png",

    firstSlideImage1 = "assets/paytable/bonus_sym_paytable.png",
    firstSlideImage2 = "assets/paytable/wild_sym_paytable.png",
    // firstSlideImage3 = "assets/paytable/cigar.png",
    // firstSlideImage4 = "assets/paytable/flower.png",
    secondSlideImage1 = "assets/paytable/hv_graphics.png",


    thirdSlideImage1 = "assets/paytable/lv_symbols.png",

    forthSlideImage1 = "assets/paytable/wild_random_graphic.png",
    forthSlideImage2 = "assets/paytable/wild_feature_land.png",



    divider_line = "assets/paytable/divider_line.png",





    //thirdSlideImage = "assets/paytable/scatter_sym.png",
    //thirdSlideImage2 = "assets/paytable/wild_sym.png",

    fifthSlideImage1 = "assets/paytable/fg_graphic.png",


    //sixthSlideImage1 = "assets/paytable/sc_06.png",

    seventhSlideImage1 = "assets/paytable/paychart.png",


}